// 올라타기 판정: 올라탈 수 있는지, 탑이 몇 층인지. 프로토타입 stackOf·canClimb 1739–1749.
// three.js를 쓰지 않는 순수 TS: 다음 단계에 packages/shared로 옮겨 방 서버가 같은 규칙으로 판정한다.

/** 탑: 맨 아래 하나 + 위에 최대 3마리 (4층). */
export const MAX_RIDERS = 3;

/** 판정에 필요한 카피바라 정보만. 화면의 Capy와 서버의 접속자 상태가 모두 이 모양을 채운다. */
export interface StackNode {
  /** 지금 올라타 있는 카피바라. */
  riding?: StackNode | null;
  /** 내 머리 위에 탄 카피바라. */
  rider?: StackNode | null;
  /** 올라타는 중이면 toBase가 목적지. */
  hop?: { toBase?: StackNode | null } | null;
  /** 다른 카피바라가 내 위에 올라와도 되는지. */
  allowRide?: boolean;
  /** 1 = 어른, 0.5 = 아기 (아기 위에는 못 탄다). */
  size: number;
  /** 누워 있으면 못 탄다 (찜질방). */
  lying?: boolean;
  /** 실내 식당에 있는 등 지금 상호작용할 수 없음. */
  unavailable?: boolean;
  /** 찜질방처럼 구역이 나뉜 방에서 다른 구역이면 못 탄다. */
  area?: string;
}

export interface Stack<N extends StackNode> { bottom: N; top: N; riders: number }

/** b가 속한 탑의 맨 아래, 맨 위, 탄 마리 수. */
export function stackOf<N extends StackNode>(b: N): Stack<N> {
  let bottom: N = b;
  while (bottom.riding || bottom.hop?.toBase) bottom = (bottom.riding || bottom.hop!.toBase) as N;
  let top: N = bottom, n = 0;
  while (top.rider) { top = top.rider as N; n++; }
  return { bottom, top, riders: n };
}

/**
 * a가 T(또는 T가 속한 탑)에 올라탈 수 있는지.
 * - 'invalid': 대상이 없거나 자기 자신, 상호작용할 수 없는 상태
 * - 'full': 이미 4층
 * - 'refused': 맨 아래 카피바라가 허락하지 않음 (아기, 누움, 다른 구역 포함)
 * - 'same-stack': 이미 같은 탑에 있음
 */
export type ClimbCheck = 'ok' | 'invalid' | 'full' | 'refused' | 'same-stack';

export function checkClimb(a: StackNode, T: StackNode | null | undefined): ClimbCheck {
  if (!T || T === a || T.unavailable) return 'invalid';
  const s = stackOf(T);
  if (s.riders >= MAX_RIDERS) return 'full';
  if (!s.bottom.allowRide || s.bottom.size < 1 || s.bottom.lying || (T.area !== undefined && a.area !== undefined && T.area !== a.area)) return 'refused';
  for (let x: StackNode | null | undefined = s.bottom; x; x = x.rider) if (x === a) return 'same-stack';
  return 'ok';
}

export const canClimb = (a: StackNode, T: StackNode | null | undefined): boolean => checkClimb(a, T) === 'ok';
